// This entrypoint initializes Datadog for Rails views
// Implementation is in common to take advantage of typescript and vitest
import { initDatadogRails } from '@betterup/common/src/utils/datadog-rails';

// Config is set on window.DATADOG_RAILS_CONFIG by the ERB template
if (window.DATADOG_RAILS_CONFIG) {
  initDatadogRails(window.DATADOG_RAILS_CONFIG);
}
